import React from "react";
import { AddToolTip } from "../../../components";

const BasicDetailsConatiner = ({ basicDetailsResponse }) => {
  console.log("ahyusy", basicDetailsResponse?.description);
  return (
    <div className="fee-summary-conatiner">
      <div className="details-card">
        <span className="fw-500 ft-14 headerDetails">
          Fee name
          {basicDetailsResponse?.name?.length <= 40 ? (
            <p className="fw-600 ft-16 valueDetails">
              {basicDetailsResponse?.name}
            </p>
          ) : (
            <AddToolTip
              className="fw-600 ft-16 valueDetails"
              name={basicDetailsResponse?.name}
            >
              {basicDetailsResponse?.name?.slice(0, 40)}...
            </AddToolTip>
          )}
        </span>

        <span className="fw-500 ft-14 headerDetails">
          Fee description
          {[null, undefined, ""].includes(basicDetailsResponse?.description) ? (
            <p
              className="fw-600 ft-16 valueDetails"
              style={{ whiteSpace: "nowrap" }}
            >
              {"-"}
            </p>
          ) : (
            <>
              {basicDetailsResponse?.description?.length <= 40 ? (
                <p className="fw-600 ft-16 valueDetails">
                  {basicDetailsResponse?.description}
                </p>
              ) : (
                <AddToolTip
                  className="fw-600 ft-16 valueDetails"
                  name={basicDetailsResponse?.description}
                >
                  {basicDetailsResponse?.description?.slice(0, 40)}...
                </AddToolTip>
              )}
            </>
          )}
        </span>
        <span className="fw-500 ft-14 headerDetails">
          Fee classification
          <p className="fw-600 ft-16 valueDetails">
            {basicDetailsResponse?.feeClassification?.name}
          </p>
        </span>
      </div>

      {/* <div className="details-card">

      </div> */}
    </div>
  );
};

export default BasicDetailsConatiner;
